import React from 'react';
import Table from 'src/components/Table';
import { createSuitesTableColumns } from 'src/components/SuitesTable/helpers';

const SuitesTableView = ({
  filteredSuites,
  onSuiteClick,
  onToggleMobileSync,
}: any) => (
  <Table
    defaultSort={{
      accessor: 'number',
      direction: 'descending',
    }}
    columns={createSuitesTableColumns(onSuiteClick, onToggleMobileSync)}
    data={filteredSuites}
    headerTop={undefined}
  />
);

export default SuitesTableView;
